/**
 * Where a running code generation has got to, as the live SSE frames reveal it,
 * and what the tool card's running row says about it.
 *
 * In its own module rather than next to the component for the same reason as
 * codeStreamTail.ts: the lint runs react-refresh/only-export-components with
 * --max-warnings 0.
 */
export type CodeGenPhase = 'thinking' | 'writing'

const RANK: Record<CodeGenPhase, number> = { thinking: 1, writing: 2 }

/** Later phases win: a late reasoning frame can never regress "Writing code…". */
export function advancePhase(prev: CodeGenPhase | null, next: CodeGenPhase): CodeGenPhase {
  if (prev === null) return next
  return RANK[next] > RANK[prev] ? next : prev
}

/**
 * Row stage while running; undefined means the card's default "Running…".
 *
 * Thinking deliberately maps to nothing: the ReasoningBlock right under the row
 * already reads "Thinking…", and two of them stacked read as a duplicate. The
 * row moves once the code starts. StageText appends the ellipsis itself.
 */
export function stageForPhase(phase: CodeGenPhase | null): string | undefined {
  return phase === 'writing' ? 'Writing code' : undefined
}
